query getValuation($input: GetValuationInput!) {
  pdf: getValuation(input: $input) {
    id
    pdf {
      status
      file {
        id
        cdnUrl
      }
    }
  }
}
